import { Injectable } from '@angular/core';
import { DetectedSwitchPage } from './datected-switch-page';
import { PlatformLocation } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DetectedSwitchPageService implements DetectedSwitchPage {

  constructor(
    private readonly location: PlatformLocation
  ) { }

  public isCategoryPage(): boolean {
    return this.location.pathname.includes('category');
  }

  public getDetectPage(isListPage: boolean, isPreparatPage: boolean): 'category' | 'search' | 'list' | 'preparat' {
    if (isPreparatPage) {
      return 'preparat';
    }
    return isListPage ? 'list' : this.isCategoryPage() ? 'category' : 'search';
  }
}
